import { ReactNode } from 'react';
import { Navbar, NavbarProps } from './Navbar';
import { Footer, FooterProps } from './Footer';

export interface LayoutProps {
  children: ReactNode;
  navbarProps?: NavbarProps;
  footerProps?: FooterProps;
  hideNavbar?: boolean;
  hideFooter?: boolean;
}

export function Layout({
  children,
  navbarProps,
  footerProps,
  hideNavbar = false,
  hideFooter = false,
}: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 via-white to-purple-50 dark:from-slate-900 dark:via-slate-900 dark:to-purple-900/20">
      {!hideNavbar && <Navbar {...navbarProps} />}
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer {...footerProps} />}
    </div>
  );
}
